var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-chip',{staticClass:"ma-2",attrs:{"color":"grey lighten-4","small":""}},[_c('strong',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.date))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }